/**
 * Diese Komponente bindet dann das jeweilige Modul ein, lädt die Seiten und übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'

import ProfessocialCalendar from '../../../../shared/components/ModuleComponents/ProfessocialCalendar/ProfessocialCalendar'

const UserDashboardCalendar: React.FC = () => {
  return (
    <ProfessocialCalendar />
  )
}
export default UserDashboardCalendar
